(() => {
  const PENDING_SUBMISSION_KEY = 'mpac-shopify-pending-submit-v3';
  const CONFIRMED_SUBMISSION_KEY = 'mpac-shopify-confirmed-submit-v3';
  const PENDING_MAX_AGE = 10 * 60 * 1000;

  function purgeLegacyPersistentDrafts() {
    try {
      const keys = [];
      for (let index = 0; index < localStorage.length; index += 1) keys.push(localStorage.key(index));
      keys.filter((key) => key?.startsWith('mpac-shopify-')).forEach((key) => localStorage.removeItem(key));
    } catch (_) { /* Storage can be unavailable in private browsing. */ }
    try {
      const sessionKeys = [];
      for (let index = 0; index < sessionStorage.length; index += 1) sessionKeys.push(sessionStorage.key(index));
      sessionKeys.filter((key) => key?.startsWith('mpac-shopify-session-draft-')).forEach((key) => sessionStorage.removeItem(key));
    } catch (_) { /* Session storage is optional. */ }
    try { indexedDB.deleteDatabase('ma-photo-a-croquer-shopify'); } catch (_) { /* IndexedDB is optional. */ }
  }

  function confirmSubmittedDraftOnCart() {
    let pending;
    try {
      pending = JSON.parse(sessionStorage.getItem(PENDING_SUBMISSION_KEY) || 'null');
    } catch (_) {
      try { sessionStorage.removeItem(PENDING_SUBMISSION_KEY); } catch (_) { /* Storage is optional. */ }
      return;
    }
    if (!pending?.token || !pending?.savedAt || Date.now() - pending.savedAt > PENDING_MAX_AGE) {
      try { sessionStorage.removeItem(PENDING_SUBMISSION_KEY); } catch (_) { /* Storage is optional. */ }
      return;
    }
    const cartPage = document.body.classList.contains('template-cart') || /^\/cart(?:\/|$)/.test(window.location.pathname);
    if (!cartPage) return;
    const submittedItemExists = [...document.querySelectorAll('[data-mpac-submission-token]')]
      .some((item) => item.dataset.mpacSubmissionToken === pending.token);
    if (!submittedItemExists) return;
    try {
      sessionStorage.removeItem(PENDING_SUBMISSION_KEY);
      sessionStorage.setItem(CONFIRMED_SUBMISSION_KEY, JSON.stringify({ token: pending.token, confirmedAt: Date.now() }));
    } catch (_) { /* Storage is optional. */ }
  }

  document.addEventListener('DOMContentLoaded', () => {
    purgeLegacyPersistentDrafts();
    confirmSubmittedDraftOnCart();
    document.querySelectorAll('.mobile-menu nav a').forEach((link) => {
      link.addEventListener('click', () => link.closest('details')?.removeAttribute('open'));
    });
  });
})();
